import React from 'react';
import {Route} from 'react-router-dom';

import GroundWater from './ground-water';
import SurfaceWater from './surface-water';
import Carriers from './carriers';
import Dams from './dams';
import WaterTreatmentPlants from './water-treatment-plants';
import WasteWaterTreatmentPlants from './waste-water-treatment-plants';
import Utilities from './utilities';
import Reservoirs from './reservoirs';
import Wells from './wells';

const Layers = () => {
  return (
    <>
      <Route path='/map' exact component={SurfaceWater} />
      <Route path='/map/surface' exact component={SurfaceWater} />
      <Route path='/map/groundwater' exact component={GroundWater} />
      <Route path='/map/dams' exact component={Dams} />
      <Route path='/map/reservoirs' exact component={Reservoirs} />
      <Route path='/map/wells' exact component={Wells} />
      <Route
        path='/map/waste-water-treatment-plants'
        exact
        component={WasteWaterTreatmentPlants}
      />
      <Route path='/map/utilities' exact component={Utilities} />
      <Route
        path='/map/water-treatment-plants'
        exact
        component={WaterTreatmentPlants}
      />
      <Route path='/map/carriers' exact component={Carriers} />
    </>
  );
};

export default Layers;
